import { IUserProfession, IUserStatus } from "utils/types";
import { UserData } from "../UserAdmin/UsersTable";

  // Filter options
  export type IUserStatusOptionKey = IUserStatus | "all"
  export const userStatusOptions:{label: string, value: IUserStatusOptionKey}[] = [
    { label: "All", value: "all" },
    { label: "Active", value: "active" },
    { label: "Suspended", value: "suspended" },
  ];

  export type IProfessionalOptionKey = IUserProfession | "all";
  export const professionOptions:{label: string; value: IProfessionalOptionKey}[] = [
    { label: "All", value: "all" },
    { label: "Medical personnel", value: "clinician" },
    { label: "Student", value: "student" },
    { label: "Others", value: "others" },
  ];

  export type ISubscriptionOptionKey = "all" | "premium";
  export const subscriptionOptions:{label: string; value: ISubscriptionOptionKey}[] = [
    { label: "All", value: "all" },
    { label: "Premium", value: "premium" },
  ];

  export type ISearchOptionKey = "john_doe" | "jane_smith" | "robert_johnson";
  export const searchOptions = [
    { label: "John Doe", value: "john_doe" },
    { label: "Jane Smith", value: "jane_smith" },
    { label: "Robert Johnson", value: "robert_johnson" },
  ];




    const courseData = [
      {
        type: "Quiz",
        title: "USMLE (United States Medical Licensing Examination)",
        mode: "Untimed",
        score: "48 / 50",
        completed: true,
      },
      {
        type: "Study",
        title: "USMLE (United States Medical Licensing Examination)",
        progress: 60,
        mode: "Untimed",
        completed: false,
      },
    ];
export const userData: UserData[] = [
  {
    key: "1",
    name: "Aaron Romney",
    email: "aaronrom@gmail.com",
    profession: "Medical personnel",
    premium: false,
    status: "active",
    activity: "Online",
    avatar: "A",
  },
  {
    key: "2",
    name: "Ben Davis",
    email: "bendavis@yahoo.com",
    profession: "Student",
    premium: false,
    status: "active",
    activity: "3m ago",
    avatar: "B",
  },
  {
    key: "3",
    name: "Christopher Evans",
    email: "chrisevans@gmail.com",
    profession: "Medical personnel",
    premium: true,
    status: "active",
    activity: "Online",
    avatar: "C",
  },
  {
    key: "4",
    name: "Esosa Osaghae",
    email: "chrisesosa@gmail.com",
    profession: "Student",
    premium: true,
    status: "active",
    activity: "45m ago",
    avatar: "E",
  },
  {
    key: "5",
    name: "Fermin Torres",
    email: "torres.fermin@gmail.com",
    profession: "Student",
    premium: true,
    status: "suspended",
    activity: "Online",
    avatar: "F",
  },
  {
    key: "6",
    name: "Gerald Martin",
    email: "geraldmartin@gmail.com",
    profession: "Student",
    premium: true,
    status: "active",
    activity: "Online",
    avatar: "G",
  },
  {
    key: "7",
    name: "Hector Fernandez",
    email: "hectofern@gmail.com",
    profession: "Student",
    premium: true,
    status: "active",
    activity: "2d ago",
    avatar: "H",
  },
  {
    key: "8",
    name: "Inigo Martinez",
    email: "inigomartinez@gmail.com",
    profession: "Student",
    premium: true,
    status: "active",
    activity: "Online",
    avatar: "I",
  },
  {
    key: "9",
    name: "Judge Westford",
    email: "jdgwest@gmail.com",
    profession: "Other",
    premium: true,
    status: "active",
    activity: "1w ago",
    avatar: "J",
  },
  {
    key: "10",
    name: "Kester Robin",
    email: "robinkester@gmail.com",
    profession: "Student",
    premium: true,
    status: "active",
    activity: "Online",
    avatar: "K",
  },
];

const modules = [
  {
    id: 1,
    title: "Module 1: Foundational Medical Knowledge",
    lessons: [
      {
        id: 1,
        title: "Lesson 1: Introduction to Anatomy",
        content: `
          <p>Anatomy is the study of the structure and relationship between body parts. It forms the foundation of medical knowledge and is crucial for understanding how the human body functions in both health and disease.</p>
          
          <p>In this lesson, we'll explore:</p>
          <ul>
            <li>Basic anatomical terminology</li>
            <li>Anatomical positions and planes</li>
            <li>Major organ systems and their locations</li>
            <li>Relationship between structure and function</li>
          </ul>
          
          <p>Human anatomy can be studied at different levels:</p>
          <ul>
            <li><strong>Gross anatomy</strong>: visible structures that can be seen with the naked eye</li>
            <li><strong>Microscopic anatomy</strong>: structures that require magnification to be seen</li>
            <li><strong>Developmental anatomy</strong>: how structures change from conception to adulthood</li>
          </ul>
          
          <p>Understanding proper anatomical terminology is essential for accurate medical communication. For example, the terms "superior" and "inferior" refer to structures that are above or below, respectively, in relation to a reference point.</p>
          
          <p>The human body is typically studied using the anatomical position, where the subject stands upright, facing forward, with arms at the sides and palms facing forward. This standardized position provides consistency in describing body parts regardless of the actual position of the individual.</p>
        `,
      },
      {
        id: 2,
        title: "Lesson 2: Biochemistry Fundamentals",
        content: `
          <p>Biochemistry is the study of chemical processes within and relating to living organisms. It's a laboratory-based science that brings together biology and chemistry, focusing on processes happening at a molecular level.</p>
          
          <p>Key areas we'll cover in this lesson include:</p>
          <ul>
            <li>Structure and function of biomolecules (proteins, carbohydrates, lipids, nucleic acids)</li>
            <li>Enzyme kinetics and metabolism</li>
            <li>Energy production in cells (ATP synthesis)</li>
            <li>Molecular basis of common diseases</li>
          </ul>
          
          <p>Proteins are complex molecules made up of amino acids arranged in a linear chain and folded into a globular form. They perform a vast array of functions within living organisms, including catalyzing metabolic reactions, replicating DNA, responding to stimuli, and transporting molecules.</p>
          
          <p>Enzymes are proteins that act as biological catalysts, speeding up chemical reactions without being consumed in the process. They are highly specific to their substrates and play essential roles in digestion, metabolism, and other vital processes.</p>
          
          <p>Understanding biochemistry is crucial for comprehending the molecular basis of disease and the mechanisms of drug action, making it fundamental to medical practice.</p>
        `,
      },
    ],
  },
];

  // Sample data
 const quizzes = [
    {
      id: "q1",
      title: "USMLE (United States Medical Licensing Examination)",
      progress: 75,
      mode: "Untimed",
      isCompleted: false,
    },
    {
      id: "q2",
      title: "USMLE (United States Medical Licensing Examination)",
      progress: 100,
      mode: "Untimed",
      isCompleted: true,
    },
    {
      id: "q3",
      title: "USMLE (United States Medical Licensing Examination)",
      progress: 42,
      mode: "Timed",
      isCompleted: false,
    },
  ]; 
